import React from 'react'
import { lowerCase } from 'lodash'
import s from './DisplayConditionNode.scss'

export default ({ field, operator, value }) => (
  <div>
    {field && <span className={s.tag}>{field}</span>}
    {lowerCase(operator)}:{' '}
    {Array.isArray(value) ? (
      value.map((val, idx) => (
        <span key={idx}>
          <span className={s.tag}>{val}</span>
          {operator === 'between' && idx === 0 ? (
            <span style={{ marginRight: '5px' }}>and</span>
          ) : (
            ''
          )}
        </span>
      ))
    ) : (
      <span className={s.tag}>{value}</span>
    )}
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/components/DisplayConditionNode/DisplayConditionNode.jsx